export default "__VITE_ASSET__CXZRo9zf__"